import React, { useState, useEffect } from "react"; // Removed useMemo to fix warning
import { Link, useLocation } from "react-router-dom";

/**
 * MENU CONFIGURATION
 */
const MENU_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "fas fa-tachometer-alt",
    paths: ["/admin/dashboard1"],
    children: [{ label: "Dashboard", path: "/admin/dashboard1" }]
  },
  {
    id: "master",
    label: "Master",
    icon: "fas fa-database",
    paths: ["/admin/student"],
    children: [{ label: "Student", path: "/admin/student" }]
  },
  {
    id: "fee",
    label: "Fee Management",
    icon: "fas fa-rupee-sign",
    paths: ["/admin/collect-fee", "/admin/fee-receipts", "/admin/fee-reports"],
    children: [
      { label: "Collect Fee", path: "/admin/collect-fee" },
      { label: "All Receipts", path: "/admin/fee-receipts" },
      { label: "Fee Reports", path: "/admin/fee-reports" }
    ]
  },
  {
    id: "tournament",
    label: "Tournaments",
    icon: "fas fa-chess",
    paths: [
      "/admin/tournaments/dashboard",
      "/admin/tournaments/list",
      "/admin/tournaments/participants",
      "/admin/tournaments/orders",
      "/admin/tournaments/income",
      "/admin/tournaments/expense",
      "/admin/tournaments/profit-loss"
    ],
    children: [
      { label: "Dashboard", path: "/admin/tournaments/dashboard" },
      { label: "Tournament List", path: "/admin/tournaments/list" },
      { label: "Players", path: "/admin/tournaments/participants" },
      { label: "Payments", path: "/admin/tournaments/orders" },
      { label: "Income", path: "/admin/tournaments/income" },
      { label: "Expenses", path: "/admin/tournaments/expense" },
      { label: "P&L", path: "/admin/tournaments/profit-loss" }
    ]
  },
  {
    id: "user",
    label: "User Management",
    icon: "fas fa-users-cog",
    paths: ["/admin/user-accounts"],
    children: [{ label: "User Accounts", path: "/admin/user-accounts" }]
  },
  {
    id: "application",
    label: "Application Form",
    icon: "fas fa-file-download",
    path: "/admin/application-form"
  }
];

const Menu = () => {
  const { pathname } = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);

  const isActive = (path) => pathname === path;

  useEffect(() => {
    // Automatically open the parent menu if a child path is active
    const currentMenu = MENU_ITEMS.find(item => 
      item.paths?.some(p => pathname.startsWith(p)) || item.path === pathname
    );
    if (currentMenu?.children) {
      setActiveMenu(currentMenu.id);
    }
  }, [pathname]);

  const toggleMenu = (e, menuId) => {
    e.preventDefault();
    setActiveMenu(prev => (prev === menuId ? null : menuId));
  };

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <Link to="/" className="brand-link">
        <img
          src="/images/pawn.png"
          alt="Logo"
          className="brand-image img-circle elevation-3"
          style={{ opacity: ".9" }}
        />
        <span className="brand-text font-weight-light">Aadhav Academy</span>
      </Link>

      <div className="sidebar">
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">
            {MENU_ITEMS.map((item) => {
              const hasChildren = !!item.children;
              // Check if current URL is inside this group to highlight parent
              const isParentActive = item.paths?.some(p => pathname.startsWith(p));
              const isOpen = activeMenu === item.id;

              return (
                <li key={item.id} className={`nav-item ${isOpen ? "menu-open" : ""}`}>
                  {hasChildren ? (
                    <>
                      {/* FIX: Changed href="#" to a role="button" to satisfy ESLint while keeping AdminLTE styles */}
                      <a
                        href="#active" 
                        role="button"
                        className={`nav-link ${isParentActive ? "active" : ""}`}
                        onClick={(e) => toggleMenu(e, item.id)}
                      >
                        <i className={`nav-icon ${item.icon}`} />
                        <p>
                          {item.label}
                          <i className="right fas fa-angle-left" />
                        </p>
                      </a>
                      <ul className="nav nav-treeview" style={{ display: isOpen ? 'block' : 'none' }}>
                        {item.children.map((child) => (
                          <li key={child.path} className="nav-item">
                            <Link
                              to={child.path}
                              className={`nav-link ${isActive(child.path) ? "active" : ""}`}
                            >
                              <i className="far fa-circle nav-icon" />
                              <p>{child.label}</p>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <Link
                      to={item.path}
                      className={`nav-link ${isActive(item.path) ? "active" : ""}`}
                    >
                      <i className={`nav-icon ${item.icon}`} />
                      <p>{item.label}</p>
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default React.memo(Menu);